import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ProblemsPage from "./pages/ProblemsPage";
import JobsPage from "./pages/JobsPage";
import ServiceNowPage from "./pages/ServiceNowPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/problems" element={<ProblemsPage />} />
          <Route path="/servicenow" element={<ServiceNowPage />} />
          <Route path="/jobs" element={<JobsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
